import React from "react";
import { Link } from "react-router-dom";
import { Radio, Users } from "lucide-react";

export default function OnNowRow({ items = [] }) {
  if (!items?.length) return null;
  return (
    <section data-testid="on-now-rail" className="mb-10">
      <div className="flex items-center gap-3 mb-3">
        <Radio className="w-5 h-5 text-[#E50914]" />
        <h2 className="text-xl md:text-2xl font-bold tracking-tight">On Now — GCR Theaters</h2>
        <Link to="/live" className="text-xs text-gray-400 hover:text-white ml-2 underline">Channel guide →</Link>
      </div>
      <div className="grid grid-flow-col auto-cols-[minmax(280px,1fr)] gap-3 overflow-x-auto pb-3 scrollbar-hide">
        {items.map((c) => (
          <Link
            key={c.channel_id}
            to={`/live/${c.slug}`}
            data-testid={`on-now-${c.slug}`}
            className="relative h-32 rounded-lg overflow-hidden group border border-white/5 hover:border-[#E50914]/40 transition-all"
          >
            <img src={c.backdrop || c.poster} alt="" className="absolute inset-0 w-full h-full object-cover opacity-50 group-hover:opacity-70 transition-opacity" />
            <div className="absolute inset-0 bg-gradient-to-r from-black/95 via-black/70 to-transparent" />
            <div className="relative z-10 p-4 h-full flex flex-col justify-between">
              <div className="flex items-center justify-between gap-2">
                <div className="flex items-center gap-2">
                  <span className="relative flex h-2 w-2">
                    <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#E50914] opacity-75"></span>
                    <span className="relative inline-flex rounded-full h-2 w-2 bg-[#E50914]"></span>
                  </span>
                  <span className="text-[10px] uppercase tracking-widest font-bold text-[#E50914]">Live · {c.name}</span>
                </div>
                {(c.viewers || 0) > 0 && (
                  <span
                    data-testid={`on-now-viewers-${c.slug}`}
                    className="flex items-center gap-1 text-[10px] font-semibold text-white/90 bg-black/60 rounded px-1.5 py-0.5"
                  >
                    <Users className="w-2.5 h-2.5 text-[#E50914]" />{c.viewers}
                  </span>
                )}
              </div>
              <div>
                <div className="text-[10px] uppercase tracking-wider text-gray-400 mb-0.5">Now playing</div>
                <div className="font-bold text-base truncate">{c.title}</div>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}
